function smoothScrollTo(element, duration = 800) {
  if (!element) return;

  const start = window.pageYOffset;
  const target = element.getBoundingClientRect().top + window.pageYOffset;
  const distance = target - start;

  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;

    const progress = Math.min(timeElapsed / duration, 1);

    // easeInOut
    const ease =
      progress < 0.5
        ? 2 * progress * progress
        : 1 - (-2 * progress + 2) ** 2 / 2;

    window.scrollTo(0, start + distance * ease);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}

export default smoothScrollTo;
